<div class="innerPagesBlock">
  <app-side-menu></app-side-menu>
  <div class="admin-panel">
    <!-- <app-banner-footer-pages [title]="title1"></app-banner-footer-pages> -->
    <!-- <app-banner-profile
      [image]="img1"
      [title]="title1"
      [customClasses]="class1"
    ></app-banner-profile> -->
    <div class="seller_approve_page">
      <app-main-heading [title]="title"></app-main-heading>
      <div class="reasons">
        <div class="reasons-head">Escalated - Can be Approved</div>
        <h3 class="reason">Reasons</h3>
        <ol type="1">
          <li>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. In alias
            quas cum quaerat
          </li>
          <li>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. In alias
            quas cum quaerat
          </li>
          <li>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. In alias
            quas cum quaerat
          </li>
          <li>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. In alias
            quas cum quaerat
          </li>
        </ol>
      </div>
      <form>
        <div class="innerpageContent mb-5">
          <div class="row">
            <div class="col-lg-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <select
                    name="pre"
                    id="pre"
                    class="regSelect"
                    formControlName="salutationId"
                  >
                    <option [ngValue]="2">Miss</option>
                    <option [ngValue]="1">Mrs</option>
                  </select>
                  <div class="inputGroupInner">
                    <input
                      onkeydown="return /[a-z ]/i.test(event.key)"
                      formControlName="name"
                      type="text"
                      id="name"
                      class="inputBox"
                      placeholder=""
                    />
                    <label for="name" class="inputLabel">First Name</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="lastName"
                  placeholder=""
                />
                <label for="lastName" class="inputLabel">Last Name</label>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  type="email"
                  formControlName="emailId"
                  class="inputBox"
                  id="emailId"
                  placeholder=""
                />
                <label for="emailId" class="inputLabel">Email ID</label>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <input
                    [disabled]="true"
                    name="pre"
                    id="pre"
                    type="text"
                    value="+91"
                    class="pre-input"
                  />

                  <div class="inputGroupInner">
                    <input
                      formControlName="mobile"
                      type="text"
                      maxlength="10"
                      class="inputBox"
                      id="mobile"
                      placeholder=""
                    />
                    <label for="mobile" class="inputLabel"
                      >Mobile Number
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="EducationQualification"
                  class="inputBox"
                  id="EducationQualification"
                  placeholder=""
                />
                <label for="EducationQualification" class="inputLabel"
                  >Education Qualification</label
                >
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="dob"
                  placeholder=""
                />
                <label for="dob" class="inputLabel">Date of Birth</label>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="businessemail"
                  placeholder=""
                />
                <label for="businessemail" class="inputLabel"
                  >Business email iD</label
                >
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="supportEmail"
                  placeholder=""
                />
                <label for="supportEmail" class="inputLabel"
                  >customer support Email ID</label
                >
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <input
                    [disabled]="true"
                    name="pre"
                    id="pre"
                    type="text"
                    value="+91"
                    class="pre-input"
                  />

                  <div class="inputGroupInner">
                    <input
                      formControlName="mobile"
                      type="text"
                      maxlength="10"
                      class="inputBox"
                      id="mobilebusiness"
                      placeholder=""
                    />
                    <label for="mobilebusiness" class="inputLabel"
                      >business number</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <input
                    [disabled]="true"
                    name="pre"
                    id="pre"
                    type="text"
                    value="+91"
                    class="pre-input"
                  />

                  <div class="inputGroupInner">
                    <input
                      formControlName="mobile"
                      type="text"
                      maxlength="10"
                      class="inputBox"
                      id="customersupport"
                      placeholder=""
                    />
                    <label for="customersupport" class="inputLabel"
                      >customer support number</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <input
                    [disabled]="true"
                    name="pre"
                    id="pre"
                    type="text"
                    value="+91"
                    class="pre-input"
                  />

                  <div class="inputGroupInner">
                    <input
                      formControlName="mobile"
                      type="text"
                      maxlength="10"
                      class="inputBox"
                      id="WhatsAppnumber"
                      placeholder=""
                    />
                    <label for="WhatsAppnumber" class="inputLabel"
                      >WhatsApp number</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="wesite"
                  placeholder=""
                />
                <label for="wesite" class="inputLabel">Wesite URL</label>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="pincode1"
                  placeholder=""
                />
                <label for="pincode1" class="inputLabel">Pincode</label>
              </div>
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="city"
                  placeholder=""
                />
                <label for="city" class="inputLabel">City</label>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <textarea
                  id="addreg"
                  formControlName="desc"
                  rows="8"
                  placeholder=""
                  class="inputBox regTextarea contareaheight"
                ></textarea>
                <label for="addreg" class="inputLabel"
                  >Write something...</label
                >
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="state"
                  placeholder=""
                />
                <label for="state" class="inputLabel">State</label>
              </div>
            </div>
          </div>
        </div>
      </form>
      <app-main-heading [title]="title2"></app-main-heading>

      <div class="document-validation-page">
        <div class="documents">
          <section class="document-type">
            <div class="doc-type-btn">pan</div>
            <div class="doc-type-btn">gst</div>
            <div class="doc-type-btn">fssai</div>
            <div class="doc-type-btn">health trade</div>
          </section>
          <div class="document-image">
            <img
              class="docFullImage"
              src="../../../assets/images/doc-img.svg"
              alt=""
            />
            <img
              class="docSmallImage"
              src="../../../assets/images/doc-sm.svg"
              alt=""
            />
          </div>
        </div>
        <div class="document-detail">
          <div class="row">
            <div class="col-lg-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <select
                    name="pre"
                    id="pre"
                    class="regSelect"
                    formControlName="salutationId"
                  >
                    <option [ngValue]="2">Miss</option>
                    <option [ngValue]="1">Mrs</option>
                  </select>
                  <div class="inputGroupInner">
                    <input
                      onkeydown="return /[a-z ]/i.test(event.key)"
                      formControlName="name"
                      type="text"
                      id="name2"
                      class="inputBox"
                      placeholder=""
                    />
                    <label for="name2" class="inputLabel">First Name</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="lastName"
                  class="inputBox"
                  id="lastName2"
                  placeholder=""
                />
                <label for="lastName2" class="inputLabel">Last Name</label>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="document-acceptence">
                <div class="accptence-text">Document Acceptance</div>
                <label class="switch">
                  <input type="checkbox" id="togBtn" />
                  <div class="slider round">
                    <span class="on">YES</span>
                    <span class="off">NO</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="col-lg-8">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <div class="inputGroupInner">
                    <input
                      onkeydown="return /[a-z ]/i.test(event.key)"
                      formControlName="name"
                      type="text"
                      id="gst"
                      class="inputBox"
                      placeholder=""
                    />
                    <label for="gst" class="inputLabel">GST Number </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">Status </mat-label>
                  <mat-select formControlName="eduQualification">
                    <mat-option>test1</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <div class="inputGroupInner">
                    <input
                      onkeydown="return /[a-z ]/i.test(event.key)"
                      formControlName="name"
                      type="text"
                      id="issueDate"
                      class="inputBox"
                      placeholder=""
                    />
                    <label for="issueDate" class="inputLabel"
                      >(GST) Issue Date</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">Status </mat-label>
                  <mat-select formControlName="eduQualification">
                    <mat-option>test1</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <div class="inputGroupInner">
                    <input
                      onkeydown="return /[a-z ]/i.test(event.key)"
                      formControlName="name"
                      type="text"
                      id="businessIncorporation"
                      class="inputBox"
                      placeholder=""
                    />
                    <label for="businessIncorporation" class="inputLabel"
                      >Business Incorporation Date</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">Status </mat-label>
                  <mat-select formControlName="eduQualification">
                    <mat-option>test1</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <div class="inputGroupInner">
                    <input
                      onkeydown="return /[a-z ]/i.test(event.key)"
                      formControlName="name"
                      type="text"
                      id="legalName"
                      class="inputBox"
                      placeholder=""
                    />
                    <label for="legalName" class="inputLabel"
                      >Business Legal Name</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">Status </mat-label>
                  <mat-select formControlName="eduQualification">
                    <mat-option>test1</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <div class="inputGroupInner">
                    <input
                      onkeydown="return /[a-z ]/i.test(event.key)"
                      formControlName="name"
                      type="text"
                      id="entityType"
                      class="inputBox"
                      placeholder=""
                    />
                    <label for="entityType" class="inputLabel"
                      >Entity Type</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">Status </mat-label>
                  <mat-select formControlName="eduQualification">
                    <mat-option>test1</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <div class="inputGroupInner">
                    <input
                      onkeydown="return /[a-z ]/i.test(event.key)"
                      formControlName="name"
                      type="text"
                      id="pincode"
                      class="inputBox"
                      placeholder=""
                    />
                    <label for="pincode" class="inputLabel">Pincode</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">Status </mat-label>
                  <mat-select formControlName="eduQualification">
                    <mat-option>test1</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="seller-categories-box">
        <div class="seller-category">
          <div class="row">
            <div class="col-lg-4">
              <div class="seller-category-title">Map Category :</div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">Map Category </mat-label>
                  <mat-select formControlName="eduQualification">
                    <mat-option>test1</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="seller-category-title">Map Sub - Category :</div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">Map Sub - Category </mat-label>
                  <mat-select formControlName="eduQualification">
                    <mat-option>test1</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="seller-category-title">Map Business type :</div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">Map Business type </mat-label>
                  <mat-select formControlName="eduQualification">
                    <mat-option>test1</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="reason-btn-box">
          <div class="reasonButtons">
            <div class="reason-btn res-red">Reject</div>
            <div class="reason-btn res-orange">Follow Up</div>
            <div class="reason-btn res-green">Approve</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
